import React from 'react'

const Client = ({ clientAddress }) => {
  return (
    <div className="flex flex-row justify-between my-10">
      <div className="flex flex-row w-1/2 whitespace-pre">{clientAddress}</div>
    </div>
  )
}

export default Client
